export const arrayOfNumbers = (length: number) =>
  Array.from({ length}, (_, i) => i);
